import { LabeledValue } from '@/data-objects/props/LabeledValue'

export class InputWithSelect {
  constructor (
    public input: number | string,
    public select: LabeledValue,
  ) {}
}
